import script from "./SkillsList.vue?vue&type=script&setup=true&lang=js"
export * from "./SkillsList.vue?vue&type=script&setup=true&lang=js"

import "./SkillsList.vue?vue&type=style&index=0&id=1ef5754e&scoped=true&lang=css"

import exportComponent from "/Users/aakash/Documents/projects/portfoilio-v2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ef5754e"]])

export default __exports__